// extracted by mini-css-extract-plugin
export var buttonContent = "_31-0";
export var centered = "_31-1";
export var centeredFlex = "_31-2";
export var errorText = "_31-3";
export var icon = "_31-4";
export var iconButtonContent = "_31-5";
export var monospace = "_31-6";
export var padded = "_31-7";